import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input,
  OnDestroy,
  Output,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { isObservable, Observable, of, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { IPills } from './pills.model';

/**
 * Pills AKA tags component. Created to initially be used with Autocomplete multiple selection.
 * It may be used for different purposes
 *
 * @export
 * @class PillsComponent
 */
@Component({
  selector: 'nibtravel-pills',
  templateUrl: './pills.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PillsComponent implements AfterViewInit, OnDestroy {
  private destroy$ = new Subject<void>();
  pills$!: Observable<IPills[]>;
  lastTabbedPillIndex?: number;
  @HostBinding('id') id = 'pills-host';
  @Input() set pills(value: IPills[] | Observable<IPills[]>) {
    this.pills$ = isObservable(value) ? value : of(value);
  }
  @Output() removed = new EventEmitter();
  @ViewChildren('pillsList') pillsList!: QueryList<ElementRef>;

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngAfterViewInit(): void {
    this.pillsList.changes.pipe(takeUntil(this.destroy$)).subscribe(() => {
      if (
        this.lastTabbedPillIndex !== undefined &&
        this.lastTabbedPillIndex !== null &&
        this.pillsList.length > 0
      ) {
        const index = Math.min(
          this.pillsList.length - 1,
          this.lastTabbedPillIndex
        );
        this.pillsList.toArray()[index].nativeElement.focus();
      }
      this.lastTabbedPillIndex = undefined;
    });
  }

  onClicked(pill: IPills): void {
    this.removed.emit(pill);
    this.lastTabbedPillIndex = undefined;
  }

  OnKeyDownEnter(index: number, pill: IPills): void {
    this.removed.emit(pill);
    this.lastTabbedPillIndex = index;
  }

  onFocus(index: number): void {
    this.lastTabbedPillIndex = index;
  }
}
